<template>
  <div class="addClient">
    <div class="name">
      {{ moduleTitle }}
    </div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleFormAddClient"
      label-width="120px"
    >
      <el-form-item label="应用ID" prop="clientID">
        <el-input
          v-model.trim="ruleForm.clientID"
          :maxlength="32 - realmName.length - 1"
          placeholder="请输入应用ID"
        >
          <template slot="prepend">{{ realmName + "-" }}</template></el-input
        >
      </el-form-item>
      <el-form-item label="选择协议" prop="agreement">
        <el-input
          v-model.trim="ruleForm.agreement"
          disabled
          placeholder="请选择协议"
        ></el-input>
      </el-form-item>

      <el-form-item label="根URL" prop="rootUrl">
        <el-input
          v-model.trim="ruleForm.rootUrl"
          placeholder="请输入根URL"
        ></el-input>
      </el-form-item>
      <el-form-item label="应用名称" prop="clientName">
        <el-input
          v-model.trim="ruleForm.clientName"
          :maxlength="32"
          placeholder="请输入应用名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="应用描述" prop="clientDesc">
        <el-input
          type="textarea"
          v-model="ruleForm.clientDesc"
          :maxlength="100"
          placeholder="请输入应用描述"
        ></el-input>
      </el-form-item>
      <el-form-item label="重定向URI" prop="redirectUrl">
        <el-input
          v-model="ruleForm.redirectUrl"
          type="textarea"
          class="redirectUrl"
          placeholder="请输入重定向URI，多个请换行"
        ></el-input>
      </el-form-item>
      <el-form-item label="应用注销URL" prop="frontChannelLogoutUrl">
        <el-input
          v-model.trim="ruleForm.frontChannelLogoutUrl"
          type="text"
          class="redirectUrl"
          placeholder="请输入应用注销URL"
        ></el-input>
      </el-form-item>
      <el-form-item label="应用状态" prop="enable">
        <el-switch v-model="ruleForm.enable"></el-switch>
      </el-form-item>
      <el-form-item>
        <div class="footer">
          <el-button type="primary" @click="submitForm">确 定</el-button>
          <el-button @click="handleCancel">取 消</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { validateUrl } from "@/common/utils.js"
import APIS from "@/apis/clientManage.js"
export default {
  data() {
    const validatelogoutUrl = (rule, value, callback) => {
      //校验以http://、https://开头的url
      let pattern = /(http|https):\/\/([\w.]+\/?)\S*/
      if (value === null || value === "") {
        callback()
      } else if(!pattern.test(value)){
        callback([new Error("URL格式不正确")])
      } else {
        callback()
      }
    }
    const checkClientID = (rule, value, callback) => {
      let pattern = /^[0-9a-zA-Z-]{1,32}$/
      value = value.trim()
      if (value === "") {
        callback(new Error("请输入应用ID"))
      } else if (!pattern.test(value)) {
        callback(new Error("支持英文、数字、中划线(-)"))
      } else {
        callback()
      }
    }
    return {
      breadcrumb: [
        {
          label: "应用管理",
          url: "/clientManage"
        },
        {
          label: "添加应用"
        }
      ],
      moduleTitle: "添加应用",
      ruleForm: {
        clientID: "",
        agreement: "OIDC",
        rootUrl: "",
        clientName: "",
        clientDesc: "",
        redirectUrl: "",
        frontChannelLogoutUrl: "",
        enable: true
      },
      transform: {
        OIDC: "openid-connect"
      },
      rules: {
        clientID: [
          { required: true, validator: checkClientID, trigger: "blur" }
        ],
        rootUrl: [
          { required: true, message: "请输入根URL", trigger: "blur" },
          { validator: validateUrl, trigger: "blur" }
        ],
        clientName: [
          { required: true, message: "请输入应用名称", trigger: "blur" }
        ],
        redirectUrl: [
          { required: true, message: "请输入重定向URI", trigger: "blur" }
          // { validator: validateRedirectUrl, trigger: "blur" }
        ],
        frontChannelLogoutUrl: [
          { required: false, message: "请输入应用注销URL", trigger: "blur" },
          { validator: validatelogoutUrl, trigger: "blur" }
        ]
      },
      realmName: this.$realm
    }
  },
  methods: {
    // 添加应用
    async addClient() {
      let params = {
        clientId: this.realmName + "-" + this.ruleForm.clientID,
        name: this.ruleForm.clientName,
        rootUrl: this.ruleForm.rootUrl,
        enabled: this.ruleForm.enable,
        redirectUris: this.ruleForm.redirectUrl
          .split("\n")
          .filter(item => item !== ""),
        protocol: this.transform[this.ruleForm.agreement],
        description: this.ruleForm.clientDesc,
        frontChannelLogoutUrl: this.ruleForm.frontChannelLogoutUrl
      }
      let { status, data } = await APIS.postRealmsClient(this.realmName, {
        data: params
      })
      if (status === 0 && data && data.id) {
        this.$router.push({
          path: "/clientManage/detailClient",
          query: {
            clientId: data.id
          }
        })
      }
    },
    // 提交添加账户表单
    submitForm() {
      this.$refs["ruleFormAddClient"].validate(valid => {
        if (valid) {
          this.addClient()
        }
      })
    },
    handleCancel() {
      this.$router.push("/clientManage")
    }
  }
}
</script>

<style lang="scss">
.addClient {
  .name {
    margin-bottom: 16px;
    padding-left: 26px;
  }

  .el-form {
    .el-form-item__error {
      white-space: nowrap;
    }
    .el-input-group__prepend {
      padding: 0 10px;
    }
  }

  .el-textarea {
    textarea {
      min-height: 80px !important;
      padding: 5px 10px;
    }
    &.redirectUrl {
      textarea {
        min-height: 66px !important;
      }
    }
  }
}
</style>
